import { Route, Switch } from 'react-router-dom'
import { useRouter } from "../../hooks/router";
import { useEffect, useState } from "react";

import NavBar from '../../components/NavBar/NavBar';
import {
    get_categories, get_channels, get_favourites, get_user_by_id, validate_token, get_profile, autoSignInSubUser
} from "../../server/requests";
import Settings from "../../components/Pages/Settings/Settings";
import HomeLive from '../HomeLive/HomeLive';

import { crypt } from "../../components/Util/util";


export default ({ network, type, configs, appSettings, isGuest }) => {

    const router = useRouter()

    const [showLoading, setShowLoading] = useState(false)
    const [listChannels, setListChannels] = useState([])
    const [allChannels, setAllChannels] = useState([])
    const [categoriesList, setCategoriesList] = useState([])
    const [resultSearch, setResultSearch] = useState([])
    const [favourites, setFavourites] = useState([])
    const [changeFav, setChangeFav] = useState(false)

    useEffect(() => {
        setShowLoading(true)
        get_categories({}, data => {
            get_favourites({}, function (res) {
                for (let i = 0; i < res.length; i++) {

                    if (res[i].type == "live_tv") {

                        for (let j = 0; j < res[i].content.length; j++) {

                            res[i].content[j].is_favourite = true

                        }

                        setFavourites([...res[i].content])
                        req_channels(res[i].content)
                        break

                    }

                }

            }, err => {
                setShowLoading(false)
            })
            function req_channels(fav_list) {
                get_all_channels(data, fav_list)
            }

        }, err => {
            if (err.toLowerCase() == 'forbidden') {
                if (router.query.token) {
                    console.log(router, 'router ')

                    is_valid(router.query.token)

                    // router.push('/auth?token=' + router.query.token)

                }
                else router.push('/auth')

            }
        })

    }, [])

    const is_valid = (_token) => {
        validate_token({ token: _token }, res => {
            localStorage.setItem('token', crypt('token', _token))

            if (router.query.root_user_id) {
                localStorage.setItem('device_id', router.query.device_id)
                localStorage.setItem('token', crypt('token', router.query.token))

                get_sub_user_by_id(router.query.token)
            } else {
                autoSignInSubUser(router)
            }
        }, err => {
            router.push('/auth')
        })
    }

    const get_sub_user_by_id = (_token) => {
        get_user_by_id({}, res => {
            console.log(res, 'responce user')
            localStorage.setItem('user', crypt('user', JSON.stringify(res)))
            router.push('/settings?a=messages')
        }, err => {
            router.push('/auth')
        })
    }

    const get_all_channels = (categories, fav_list) => {

        let obj = {
            archive: false,
            color: "#fff",
            id: Date.now(),
            image: "",
            name: "All",
            position: 0,
            status: 0,
            channels: [],
            selected: true
        }
        let obj_fav = {
            archive: false,
            color: "#fff",
            id: Date.now() + 10,
            image: "",
            name: "Favourites",
            position: 0,
            status: 0,
            channels: [...fav_list],
            selected: false
        }

        let _categories = categories


        _categories.unshift(obj_fav)

        _categories.unshift(obj)



        setCategoriesList([..._categories])

        get_channels({}, data => {

            setShowLoading(false)
            setAllChannels([...data])
            for (let i = 0; i < data.length; i++) {

                data[i].is_favourite = obj_fav.channels.some(e => e.id == data[i].id)

                obj.channels.push(data[i])

                for (let j = 0; j < data[i].categories.length; j++) {

                    let category = _categories.find(e => e.id == data[i].categories[j])

                    if (category) {
                        if (!category.channels) category.channels = []
                        data[i].selected = false
                        category.channels.push(data[i])
                    }

                }

            }


            setListChannels([..._categories])
            setResultSearch([..._categories])
        }, err => {

            if (err.toLowerCase() == 'forbidden') {
                if (router.query.token) {

                    is_valid(router.query.token)

                    // router.push('/auth?token=' + router.query.token)

                }
                else router.push('/auth')

            }
        })
    }

    useEffect(() => {

        if (router.query.search && listChannels.length) {

            if (allChannels.length) {

                let _categories = JSON.parse(JSON.stringify(listChannels))

                for (let i = 0; i < _categories.length; i++) {

                    if (_categories[i].channels && _categories[i].channels.length) {

                        let new_array_channels = _categories[i].channels.filter(e => e.name.toLowerCase().indexOf(router.query.search.toLowerCase()) > -1)

                        _categories[i].channels = [...new_array_channels]

                    }

                }

                setResultSearch([..._categories])

            }

        } else {

            let _categories = [...listChannels]

            setResultSearch([..._categories])
            if (router.query.id && !router.query.type) router.push(`?id=${router.query.id}`)

        }
    }, [router.query.search])

    // useEffect(()=>{
    //     document.body.onwheel = scroll_home_page
    // },[])
    //
    // function scroll_home_page(e){
    //     if(e.deltaY < 0){
    //         setClassNavBar('navbar')
    //     }else{
    //         setClassNavBar('navbar hide')
    //     }
    // }


    return (

        <div className={'conteiner'}>

            <NavBar NavClass={'navbar'} type={type} configs={configs} />

            <div
                className={"main " + (type == 'live' ? "live" : "")} /*style={{top:router.pathname.split('/')[1] !== 'search'?'50%':'10rem',transition:'0 !important'}}*/>
                <Switch>

                    <Route exact path={'/'}>
                        <HomeLive
                            favourites={favourites}
                            showLoading={showLoading}
                            setResultSearch={setResultSearch}
                            listChannels={resultSearch}
                            allChannels={allChannels}
                            appSettings={appSettings}
                            configs={configs}
                        />
                    </Route>

                    <Route path={'/settings'}>

                        <Settings configs={configs} appSettings={appSettings} />
                    </Route>


                </Switch>
            </div>
        </div>
    )
}